import OsmDirection from '../OsmMap/Direction';
import MapBoxDirection from '../MapBox/Direction';
import { OSM_MAP } from '../';

const mapType = import.meta.env.VITE_MAP;

const Direction = (props) => {
  if (mapType === OSM_MAP) {
    return <OsmDirection {...props} />;
  }

  return <MapBoxDirection {...props} />;
};

export default Direction;
